// removed by extract-text-webpack-plugin
module.exports = {"Button":"_2VHxLUUkqriAyC_fyHqhwc","Button--small":"_2HiRMOgmPamo_Ebw-bt5B4","Button--lite":"_1fscjHegLhkEllxWM9yH8q","Button--fat":"_24MLQroS5sd2mz3tc12sNn","Button--fullWidth":"_3Eam2hgN8VENJjl2VrOX-1","Button--secondary":"_3wU_-aRurhTbwvTnD9D5Vo","Button--primary":"_1nguLVw7YwQ9kMvBZYmv0m","Button--territory":"_3xzeEAa4kNCZzixGK9rx6h","Button--purchased":"_1vPBUlQdXRjxPSDYoZxrz4","Button--slim":"_2zLqdkPCA_duqCUdCI3f-q","Button--smallSize":"_2Ja_VJ-F1ybWc1MhWL0bHU"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicEula/components/Button.scss
// module id = 2851
// module chunks = 0